import {  ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { GlobalSearchService } from 'app/services/globalsearchservice.service';
import { OmsService } from 'app/services/oms.service';
import { OrdersService } from 'app/services/orders.service';
import { UsersService } from 'app/services/users.service';
import { InventoryService } from 'app/services/inventory.service';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { Observable } from 'rxjs';
import { PrintService } from 'app/services/print.service';


@Component({
	selector: 'app-sticker-payment-processing',
	templateUrl: './sticker-payment-processing.component.html',
	styleUrls: ['./sticker-payment-processing.component.scss'],
})
export class StickerPaymentProcessingComponent implements OnInit {
	config: any = false;
	user: any = false;
	allitems = [];
	color: any = 'blue';
	warnonly: boolean = false;
	allitems_unfiltered: any = false;
	itemsloading: any = false;
	dataSource: MatTableDataSource < any > ;
	@ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
	dataObs: Observable < any > ;
	pagesizedefault: number = 500;
	items_per_page: any = [50,100,250,500];
	filename: any = 'FETreport';
	searchRef = new UntypedFormControl('');
	exportingPDF: boolean = false;
	exportingXLS: boolean = false;

	constructor(private printService: PrintService, private cd: ChangeDetectorRef, private inventoryService: InventoryService, private omsService: OmsService, private usersService: UsersService, private modalService: NgbModal, private globalSearchService: GlobalSearchService, private ordersService: OrdersService) { }

	ngOnInit(): void {
		this.globalSearchService.configsubscription.subscribe(r => {
			this.config = r;
			this.globalSearchService.user.subscribe(u => {
				this.user = u;
			})
		});
		this.color = this.globalSearchService.getColor();
		this.getfetitems();
		this.searchRef.valueChanges.subscribe((newV)=>{
			this.search(newV);
		})
	}

	filter(){
		this.warnonly = !this.warnonly;
		this.allitems = this.warnonly ? this.allitems_unfiltered.filter((i)=>i.warn == true) : this.allitems_unfiltered
		if(this.searchRef.value){
			this.search(this.searchRef.value);
		}else{
			this.setPagination(this.allitems);
		}
	}

	search(ev){
		ev = ev.toLowerCase();
		var pool = this.warnonly ? this.allitems_unfiltered.filter((i)=> i.warn == true) : this.allitems_unfiltered;
		if(ev.value == ''){
			this.allitems = pool;
		}else{
			this.allitems = pool.filter((i)=>i.stockid.toLowerCase().includes(ev) || i.description.toLowerCase().includes(ev) || i.name.toLowerCase().includes(ev));
		}
		this.setPagination(this.allitems);
	}

	setPagination(tableData) {
		this.dataSource = new MatTableDataSource < any > (tableData);
		this.cd.detectChanges();
		this.dataSource.paginator = this.paginator;
		this.dataObs = this.dataSource.connect();
	}

	getfetitems(){
		if(this.itemsloading){
			this.itemsloading = false;
		}
		this.itemsloading = this.inventoryService.getFetItems().subscribe((res: any)=>{
			this.itemsloading = false;
			this.allitems = res;
			this.allitems_unfiltered = res;
			this.setPagination(this.allitems);
		})
	}


	exportPdf() {
		if(!this.allitems.length){return;}
		this.exportingPDF = true;
		const encoded: string = this.globalSearchService.base64encode(this.buildhtml());
		const today = new Date();
		const data = {
			content: encoded,
			filename: this.filename,
			title: 'Fet Item Report',
			subtitle: 'Created '+today.toLocaleString()
		}

		this.printService.pdf(data).subscribe((result: any) => {
			this.globalSearchService.downloadPdf(result.content, data.filename);
			this.exportingPDF = false;
		});
	}

	exportXls() {
		if(!this.allitems.length){return;}
		this.exportingXLS = true;
		const encoded: string = this.globalSearchService.base64encode(this.buildhtml());
		const today = new Date();
		const data = {
			content: encoded,
			filename: this.filename,
			title: 'Fet Item Report',
			subtitle: 'Created '+today.toLocaleString()
		}

		this.printService.xls(data).subscribe((result: any) => {
			this.globalSearchService.downloadXls(result.content, data.filename);
			this.exportingXLS = false;
		});
	}

	buildhtml(){
		var html = '<table style="width: 100%;"><thead><tr>';
			html +=`<th>Stockid</th>`;
			html +=`<th>Brand</th>`;
			html +=`<th>Description</th>`;
			html +=`<th>MFGPART</th>`;
			html +=`<th>FET (current)</th>`;
			html +=`<th>FET (atd)</th>`;
			html +=`<th>FET (fkl)</th>`;
			html +=`<th>FET (thub)</th>`;
			html +=`</tr></thead><tbody>`;
		this.allitems.forEach((i)=>{
			html += '<tr>'
			html += `<td>${i.stockid}</td>`
			html += `<td>${i.name}</td>`
			html += `<td>${i.description}</td>`
			html += `<td>${i.mfgpart}</td>`
			html += `<td>${i.currentfet}</td>`
			html += `<td>${i.fetatd}</td>`
			html += `<td>${i.fetfkl}</td>`
			html += `<td>${i.fetthub}</td>`
			html += '</tr>'
		})
			html +='</tbody></table>';
		return html;
	}


	normalize(time){
		const date = new Date(time.replace(" ", "T"));
		const options: any = {
			year: '2-digit',
			month: '2-digit',
			day: '2-digit',
			hour: 'numeric',
			minute: '2-digit',
			hour12: true
		};
		return new Intl.DateTimeFormat('en-US', options).format(date).replace(',','  ');
	}
}
